"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsLogsReportFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DmsDateTimeRangePicker = require("../DmsDateTimeRangePicker/DmsDateTimeRangePicker");
var _DmsButton = require("../DmsButton/DmsButton");
var _DmsLogsByThingPKTable = require("./DmsLogsByThingPKTable");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _HttpStatus = require("../../constants/HttpStatus");
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _ExportFormats = require("../../constants/ExportFormats");
var _DateTimeFormats = require("../../constants/DateTimeFormats");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsLogsReportFilter = () => {
  const [stations, setStations] = (0, _react.useState)([]);
  const [selectedStation, setSelectedStation] = (0, _react.useState)("");
  const [startDate, setStartDate] = (0, _react.useState)(null);
  const [endDate, setEndDate] = (0, _react.useState)(null);
  const [fileFormat, setFileFormat] = (0, _react.useState)(_ExportFormats.EXPORT_FORMATS.PDF);
  const contentType = 'application/json';
  const accept = "application/octet-stream";
  (0, _react.useEffect)(() => {
    const fetchStations = async () => {
      const response = await (0, _DmsFetch.fetchData)("/station/all", "GET", true);
      if (response.status === _HttpStatus.HTTP_STATUS.OK_200) {
        const stationList = response.data.data.map(station => ({
          label: station.name,
          value: station.thing_pk
        }));
        const modifiedStationList = [{
          label: "-",
          value: 'null'
        }, ...stationList];
        setStations(modifiedStationList);
      }
    };
    fetchStations();
  }, []);
  const handleFileDownload = async () => {
    try {
      if (selectedStation === "") {
        return;
      }
      const filterData = JSON.stringify([{
        name: "created_on",
        value: {
          startDate: startDate ? startDate.format(_DateTimeFormats.DATE_TIME_FORMATS.YEAR_MONTH_DAY_HOUR_MINUTE_SECOND) : null,
          endDate: endDate ? endDate.format(_DateTimeFormats.DATE_TIME_FORMATS.YEAR_MONTH_DAY_HOUR_MINUTE_SECOND) : null
        }
      }]);
      const apiUrl = "/get_logs_by_thing/export/".concat(selectedStation, "?format=").concat(fileFormat, "&filter=").concat(encodeURIComponent(filterData));
      const response = await (0, _DmsFetch.fetchData)(apiUrl, 'GET', true, null, false, null, null, null, contentType, true, accept);
      if (response.status !== _HttpStatus.HTTP_STATUS.OK_200) {
        throw new Error(_reactIntlUniversal.default.get("FailedToDownloadFile").d("Failed to download file: ".concat(response.status)));
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const handleDateChange = _ref => {
    let {
      startDate,
      endDate
    } = _ref;
    setStartDate(startDate);
    setEndDate(endDate);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      gap: 2,
      width: "100%",
      padding: 2,
      flexWrap: "nowrap"
    }
  }, /*#__PURE__*/_react.default.createElement(_material.TextField, {
    select: true,
    label: _reactIntlUniversal.default.get("Station").d("Station"),
    value: selectedStation,
    onChange: e => setSelectedStation(e.target.value),
    sx: {
      width: "10.4vw"
    }
  }, stations.map(station => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: station.value,
    value: station.value
  }, station.label))), /*#__PURE__*/_react.default.createElement(_material.TextField, {
    select: true,
    label: _reactIntlUniversal.default.get("Format").d("Format"),
    value: fileFormat,
    onChange: e => setFileFormat(e.target.value),
    sx: {
      width: "7.8vw"
    }
  }, Object.entries(_ExportFormats.EXPORT_FORMATS).map(_ref2 => {
    let [key, value] = _ref2;
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: key,
      value: value
    }, key, " (", value, ")");
  })), /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_DmsDateTimeRangePicker.DmsDateTimeRangePicker, {
    name: "dateRange",
    onChange: handleDateChange
  })), /*#__PURE__*/_react.default.createElement(_DmsButton.DmsButton, {
    variant: "success",
    onClick: handleFileDownload
  }, _reactIntlUniversal.default.get("Generate").d("Generate"))), selectedStation !== "" && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      marginTop: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_DmsLogsByThingPKTable.DmsLogsByThingPKTable, {
    thing_pk: selectedStation
  })));
};
exports.DmsLogsReportFilter = DmsLogsReportFilter;